<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list dense>
        <v-list-item link to="/">
          <v-list-item-action>
            <v-icon>mdi-account-switch</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('app.status') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/requests">
          <v-list-item-action>
            <v-icon>mdi-account-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('app.requests') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/connections">
          <v-list-item-action>
            <v-icon>mdi-transit-connection-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('app.connections') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/locations">
          <v-list-item-action>
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('app.locations') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/graph">
          <v-list-item-action>
            <v-icon>mdi-graphql</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('app.graph') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/settings">
          <v-list-item-action>
            <v-icon>mdi-cog-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('app.settings') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/help/0">
          <v-list-item-action>
            <v-icon>mdi-help</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('app.help') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/about">
          <v-list-item-action>
            <v-icon>mdi-information</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('app.about') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-btn small color="secondary" dark to="/">
        <v-icon small>mdi-account-switch</v-icon>
      </v-btn>
      <v-btn small color="secondary" dark to="/connections" class="mx-1">
        <v-icon small>mdi-transit-connection-variant</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <!-- Show QR code dialog -->
      <!--
      <v-tooltip bottom>
         <template v-slot:activator="{ on }">
          <v-btn small color="secondary" dark v-on="on" @click="showQRDialog">
            <v-icon small>mdi-qrcode</v-icon>
          </v-btn>
         </template>
         <span>{{ $t('app.tooltipSend') }}</span>
      </v-tooltip>
      -->
      <v-btn small color="secondary" dark @click="showQRDialog">
        <v-icon small>mdi-qrcode</v-icon>
      </v-btn>
      <v-dialog v-model="dialogShow" persistent max-width="350" light>
        <v-card>
          <v-card-title class="d-flex justify-end ma-0">
              <v-icon @click="closeQRDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-subtitle>
            <v-row justify="center">
              <h3 v-if="nick">{{ nick }}</h3>
              <h3 v-else>{{ pid }}</h3>
            </v-row>
          </v-card-subtitle>
          <v-card-text>
            <v-row justify="center">
              <vue-qrcode :value="link" :width="200" :maskPattern="0" :margin="0"/>
            </v-row>
            <v-row justify="center">
              <h4>meeconn</h4>
            </v-row>
            <v-row class="mt-4">
              <v-col cols="10" class="py-0">
                <v-text-field
                  v-model="linkNick"
                  :counter="50"
                  :label="$t('app.att.linkNick')"
                  @change="checkLinkNick"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="px-0 py-4">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon class="pt-2" v-on="on">mdi-information</v-icon>
                  </template>
                  <span>{{ $t('app.linkNickTooltip') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center pt-2">
              <v-btn v-if="!shareVisible" color="primary" small @click="shareVisible = true">{{ $t('app.btn.send')}}</v-btn>
            </v-row>
            <v-row v-if="shareVisible" justify="center" class="pt-0 mt-4">
              <a class="ma-1" :href="link">Link</a>
              <v-icon class="mx-1" @click="activateShare">mdi-link-variant</v-icon>
              <email class="mx-1" :url="link" subject="meeconn connection" scale="2"></email>
              <whats-app class="mx-1" :url="link" title="meeconn" scale="2"></whats-app>
              <telegram class="mx-1" :url="link" scale="2"></telegram>
              <facebook class="mx-1" :url="link" scale="2"></facebook>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon class="ml-8" v-on="on">mdi-information</v-icon>
                </template>
                <span>{{ $t('app.linkShare') }}</span>
              </v-tooltip>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="closeQRDialog">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--
      <v-tooltip bottom>
         <template v-slot:activator="{ on }">
          <v-btn small color="secondary" dark v-on="on" to="/c" class="mx-1">
            <v-icon small>mdi-qrcode-scan</v-icon>
          </v-btn>
         </template>
         <span>{{ $t('app.tooltipScan') }}</span>
      </v-tooltip>
      -->
      <!--
      <v-btn small color="secondary" dark to="/c" class="mx-1">
        <v-icon small>mdi-qrcode-scan</v-icon>
      </v-btn>
      -->
      <v-btn small color="secondary" dark @click="dialogScan = true" class="mx-1">
        <v-icon small>mdi-qrcode-scan</v-icon>
      </v-btn>
      <McScanner :dialogScan.sync="dialogScan"></McScanner>
      <!-- Show scan QR code dialog -->
      <!--
      <v-dialog v-model="dialogScan" persistent max-width="350" light>
        <template v-slot:activator="{ on }">
          <v-btn rounded color="secondary" dark v-on="on" class="mx-2">
            <v-icon>mdi-transit-connection-variant</v-icon>
          </v-btn>
        </template>
        <McScanner v-if="dialogScan" @toSynchronize="synchronizeAndRoute" @toClose="dialogScan = false"/>
      </v-dialog>
      <v-tooltip bottom>
         <template v-slot:activator="{ on }">
          <v-btn small color="secondary" dark v-on="on" @click="synchronize">
            <v-icon small v-if="!progress">mdi-sync</v-icon>
            <v-progress-circular
              v-if="progress"
              size="20"
              indeterminate
            ></v-progress-circular>
          </v-btn>
         </template>
         <span>{{ $t('app.tooltipSync') }}</span>
      </v-tooltip>
    -->
      <v-btn small color="secondary" dark @click="synchronize">
        <v-icon small v-if="!progress">mdi-sync</v-icon>
        <v-progress-circular
          v-if="progress"
          size="20"
          indeterminate
        ></v-progress-circular>
      </v-btn>
    </v-app-bar>

    <v-content>
      <v-container ma-0 pa-0 fill-height align-start>
        <router-view @error="showError" @info="showInfo" @toSynchronize="synchronize" />
      </v-container>
    </v-content>

    <v-footer app>
      <v-row justify="center">
        <span class="font-weight-thin caption">&copy; 2020 meeconn</span>
      </v-row>
    </v-footer>
    <v-snackbar
      v-model="infoSnackbar"
      :timeout="infoTimeout"
      color="info"
    >
      {{ infoText }}
      <v-btn
        text
        @click="infoSnackbar = false"
      >
        OK
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="errorSnackbar"
      :timeout="errorTimeout"
    >
      {{ errorText }}
      <v-btn
        color="red"
        text
        @click="errorSnackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import McScanner from '@/components/McScanner.vue'
import VueQrcode from 'vue-qrcode'
import { mapGetters } from 'vuex'
import {
  Facebook,
  Telegram,
  WhatsApp,
  Email,
} from "vue-socialmedia-share";

  export default {
    components: {
      McScanner,
      VueQrcode,
      Email,
      WhatsApp,
      Telegram,
      Facebook
    },
    props: {
      source: String,
    },

    data: () => ({
      drawer: null,
      dialogShow: false,
      dialogScan: false,
      shareVisible: false,
      errorText: "Error occured!",
      errorSnackbar: false,
      errorTimeout: 3000,
      infoText: "Info",
      infoSnackbar: false,
      infoTimeout: 5000,
      progress: false,
      linkNick: '',
      cor: ''
    }),

    computed: {
      link: function() {
        return encodeURI(this.$http.defaults.baseURL + '/c/' + this.cor + ';' + this.pid + (this.nick ? ';' + this.nick : ''))
      },
      ...mapGetters({
          pid: 'pid',
          nick: 'nick'
      })
    },
    async mounted() {
        try {
          this.progress = true
          await this.$store.dispatch('init')
          this.progress = false
        } catch (err) {
            this.progress = false
            this.showError(err)
        }
        if (this.$store.state.iid === '') {
          try {
            var path = "/settings"
            if (this.$route.params.link) {
                path += "/" + this.$route.params.link
            }
            await this.$router.push({path: path})
          } catch {
            //
          }
        }
    },

    methods: {
      activateShare() {
        if (this.navigator.share !== undefined) {
          this.navigator.share(
            {
              title: 'meeconn',
              text: 'Připoj si mě do meeconn sítě...',
              url: this.link
            })
            .then(() => this.showInfo('Link byl nasdílen.'))
            //.catch(err => this.showError('Link se nepovedlo nasdílet. ' + err))
            .catch()
        } else {
          this.showInfo('Tato funkce není ve Vašem prohlížeči podporovaná.')
        }
      },
      showQRDialog() {
        this.shareVisible = false
        this.linkNick = ''
        this.cor = this.$store.getters.getOTP
        this.dialogShow = true
      },
      closeQRDialog() {
        this.dialogShow = false
        this.synchronizeAndRoute()
      },
      checkLinkNick() {
        if (this.linkNick === '') {
          this.linkNick = this.$store.getters.getOTP
          this.cor = this.linkNick
        } else {
          this.$store.commit('storeLinkNick', {cor: this.cor, linkNick: this.linkNick})
        }
      },
      async synchronize() {
        if (this.$store.state.iid === '') {
          this.showInfo(this.$t('app.registrRequired'))
          return
        }
        try {
          this.progress = true
          await this.$store.dispatch('synchronize')
          await this.$store.dispatch('loadRequests')
          this.progress = false
        } catch (err) {
            this.progress = false
            this.showError(err)
        }
      },
      async synchronizeAndRoute() {
        await this.synchronize()
        try {
          await this.$router.push({path: "/connections"})
        } catch {
          //
        }
      },
      showInfo(text) {
        this.infoText = text
        this.infoSnackbar = true
      },
      showError(text) {
        this.errorText = this.$t('app.error') + ' ' + text
        this.errorSnackbar = true
      }
    },
    created () {
      this.$vuetify.theme.dark = true
    },
  }
</script>
<style>
.v-navigation-drawer {
  z-index: 999 !important;
}
</style>
